/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon64Regular = forwardRef('DataChartBarsAUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M51.5 9a1.5 1.5 0 0 1 1.5 1.5v41a1.5 1.5 0 0 1-3 0v-41A1.5 1.5 0 0 1 51.5 9Z" }),
        React.createElement("path", { d: "M40 19.5a1.5 1.5 0 0 0-3 0v32a1.5 1.5 0 0 0 3 0v-32Z" }),
        React.createElement("path", { d: "M14 37.5a1.5 1.5 0 0 0-3 0v14a1.5 1.5 0 0 0 3 0v-14Z" }),
        React.createElement("path", { d: "M27 28.5a1.5 1.5 0 0 0-3 0v23a1.5 1.5 0 0 0 3 0v-23Z" })));
});
